import { render, staticRenderFns } from "./DialogContainer.vue?vue&type=template&id=0bb826ce&scoped=true&"
import script from "./DialogContainer.vue?vue&type=script&lang=js&"
export * from "./DialogContainer.vue?vue&type=script&lang=js&"
import style0 from "./DialogContainer.vue?vue&type=style&index=0&id=0bb826ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb826ce",
  null
  
)

export default component.exports